import React, { useEffect, useState } from "react";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ShareIcon from "@mui/icons-material/Share";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CommentIcon from "@mui/icons-material/Comment";
import axios from "axios";
import {useNavigate} from "react-router-dom";
// import ShareLink from "../ShareLink";

const News = () => {
  const navigate= useNavigate()
  const [data, setData] = useState([]);

  const blogData = () => {
    axios
      .post("https://m1blog.aaragroups.com/blog/store-based-news-list-api/",{store_id:5}
      )
      .then((res) => {
        console.log("RESPONSE ==== : ", res.data?.news_details);
        setData(res.data?.news_details);
      })
      .catch((err) => {
        console.log("ERROR: ====", err);
      });
  };
  
  useEffect(() => {
    blogData();
  }, []);

  return (
    <>
      <div className="lg:px-28 px-5 bg-[#f0f5fc] hm1 ">
        <div className="flex flex-col justify-center items-center">
          <p className="lg:text-5xl text-3xl font-bold lg:pt-12 pt-5 lg:pb-4 pb-3 text-white">
            Latest News
          </p>
          <p className="text-xl text-white">
            Get the latest News from our work, writing, discuss and share
          </p>
          <p className="lg:text-3xl text-xl font-semibold lg:pt-10 pt-5 text-white">
            POPULAR NEWS
          </p>
        </div>
        <div className="grid lg:grid-cols-3 grid-cols-1 lg:gap-10 gap-2 lg:py-10 py-3">
          {data?.map((item) => {
            return (
              <div onClick={()=>navigate(`/newsdetail/${item.id}`)} className="p-5  bg-gray-400 px-8 rounded-md bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-40 border border-gray-100">
                <div className="flex justify-center items-center">
                  <img src={item?.images} alt="" className="w-60 h-60" />
                </div>
                <p className="text-lg font-semibold text-[#3b368c] py-1 px-6">
                  {item?.Title}
                </p>
                <p className="text-xs  px-6">{item?.created_at}</p>
              </div>
            );
          })}
        </div>

        <hr />

        {data?.map((item) => {
          return (
            <div className="px-10 lg:flex-row flex flex-col lg:gap-40 gap-3 mb-4 py-8 text-[#3b368c] bg-gray-400 rounded-xl bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-20 border border-gray-100">
              <div>
                <img src={item?.images} className="lg:w-48 lg:h-48 w-full" alt="" />

               {/* <div className="py-1 pt-2 pl-8 bg-white rounded-full "><ShareLink url={window.location.href} variantImage={item.images} variantName={item.Title}/></div> */}

              </div>
              <div className="flex flex-col justify-between lg:w-2/3 w-full">
                <div className="lg:text-4xl text-2xl font-semibold text-white">
                  {item?.Title}
                </div>
                <div className=" flex lg:gap-0 gap-3 lg:pt-1 pt-2 justify-between">

                  <p className="p-1 px-2 border rounded-md text-blue-600 border-blue-600">
                    <AccountCircleIcon /> by
                  </p>

                  <p className="p-1 px-2 border rounded-md text-blue-600 border-blue-600">
                    15k <RemoveRedEyeIcon />
                  </p>
                  <p className="p-1 px-2 border rounded-md text-blue-600 border-blue-600"> 3k <CommentIcon /></p>

                </div>
              </div>
            </div>
          );
        })}

        <hr />
      </div>
    </>
  );
};

export default News;
